import axios from 'axios'
import { getToken } from '@/utils/auth'
import {
    getQueryString
} from '@/utils/location'

// 创建axios
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    timeout: 20000 // request timeout
})
// 添加请求拦截器
service.interceptors.request.use(function(config) {

    if (config.data == '' ||config.data == undefined ||config.data == null) {
        config.data = new Object();
    }
    config.data.pt = "zk";
    config.data.key = getQueryString('key');
	config.data.appid = process.env.VUE_APP_BASE_APPID
	config.data.versionCode = 1

    // let token = getToken();
    // if (token) {
    //     config.headers['wancms-users-token'] = token;
    // }

    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
service.interceptors.response.use(function(response) {
    // 对响应数据做点什么

    return response;
}, function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});
export default service;